import type { MultiModalComponentData } from '@whelk/const/src/textSseConst';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const INPUT_MODE = {
  UNABLE: 'unable', // 禁用态
  CAN_SEND: 'canSend', // 可以发送态 具体是 电话 还是语音 逻辑还是放在 input组件里面根据 各种value & ua 判断比较好
  REPLYING: 'replying', // 正在请求模型回复，此时展示停止生成按钮，具体是禁用态还是 可用态，还是在input里面根据UI状态判断。不然会频繁set 这个值
} as const;

export type InputModeEnum = (typeof INPUT_MODE)[keyof typeof INPUT_MODE];

const initialState = {
  inputMode: INPUT_MODE.CAN_SEND as InputModeEnum,
  multiModalComponentInfo: {} as MultiModalComponentData,
  isCanStopReply: false, // 用户是否可以停止回复flag
};

export const inputSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setInputMode: (state, action: PayloadAction<InputModeEnum>) => {
      state.inputMode = action.payload;
      console.log('setInputMode', action.payload);
      // 每次设置 inputMode 为 CAN_SEND 时，将 isCanStopReply 重置为 false
      if (action.payload === INPUT_MODE.CAN_SEND) {
        state.isCanStopReply = false;
      }
    },
    setMultiModalComponentInfo: (state, action: PayloadAction<MultiModalComponentData>) => {
      state.multiModalComponentInfo = action.payload;
    },
    setMultiModalComponentFileID: (state, action: PayloadAction<string>) => {
      state.multiModalComponentInfo.fileID = action.payload;
    },
    setMultiModalComponentFileURL: (state, action: PayloadAction<string>) => {
      state.multiModalComponentInfo.fileUrl = action.payload;
    },
    setIsCanStopReply: (state, action: PayloadAction<boolean>) => {
      state.isCanStopReply = action.payload;
    },
  },
});

export const {
  setInputMode,
  setMultiModalComponentInfo,
  setMultiModalComponentFileID,
  setMultiModalComponentFileURL,
  setIsCanStopReply,
} = inputSlice.actions;

export default inputSlice.reducer;
